import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LPSideBySideCol from './LPSideBySideCol/l.p.sidebyside.col.vue';
import { cloneDeep } from 'lodash';
import * as T_T from 'cryface';

@Component({
    components: {
        LPSideBySideCol
    }
})
export default class LPSideBySide extends Vue {
    public title: string = 'LPSideBySide';

    public fileds: any = {
        'title': 'Property',
        'MLS#:': '',
        'List Price': '',
        'Price': '',
        'Address:': '',
        // 'Municipality:': 'Toronto',
        'Community:': '',
        'Listing Type': '',
        'Brokerage': '',
        'List Entry Date': '',
        'Sold Date': '',
        'DOM': '',
        'Postal Code:': '',
        'Cross Streets:': '',
        'PropertyType:': '',
        'Ownership': '',
        'Bedrooms': '',
        'Bedroom plus': '',
        'Washrooms': '',
        'Garages': '',
        'ApproxAge': '',
        'Basements': '',
        'Storey': '',
        'BuiltYear': '',
        'Lot Area': '',
        'Usage Area': '',
        'picture': '',
    };

    @Prop({
        default: () => {
            return {
                comparitives: [],
                prediction: 0,
            };
        }
    })
    public cmaResult: any;

    @Prop({ default: undefined })
    public data: any;

    @Prop({ default: 2 })
    public page: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

}
